export const EmotionRateLevel = {
	'emotion:lonely': -2,
	'emotion:excited': 2,
	'emotion:happy': 2,
	'emotion:love': 2,
	'emotion:calm': 1,
	'emotion:grateful': 1,
	'emotion:confident': 1,
	'emotion:neutral': 0,
	'emotion:ok': 0,
	'emotion:sad': -1,
	'emotion:tired': -1,
	'emotion:frustrated': -1,
	'emotion:distressed': -1,
	'emotion:unsafe': -1,
	'emotion:down': -1,
	'emotion:overwhelmed': -2,
	'emotion:angry': -2,
	'emotion:anxious': -2,
	'emotion:stressed': -2,
};
